import { Button, Icon, message, Upload } from "antd";
import { ShowUploadListInterface, UploadFile } from "antd/lib/upload/interface";
import api, { WisdomCashierTemplate } from "api";
import { AppForm, AppFormItemEnum, AppFormLayout, AppFormPageProps } from 'qcc';
import React from 'react';
let printStyleOption = [
  { label: 'A4竖版打印', value: 'hb' },
  { label: 'A4横版打印', value: 'sb' }
]
let printCountOption = [
  { label: '一式一份', value: 'yy' },
  { label: '一式两份', value: 'yl' },
  { label: '一式三份', value: 'ys' },

]
let printTypeOption = [
  { label: '单面打印', value: 'dm' },
  { label: '双面打印', value: 'sm' }
]

export default class PosBankEditForm extends React.PureComponent<AppFormPageProps> {
  refAppForm = React.createRef<AppForm>()
  state = {
    fileList:
      this.props.mode === 2 ? (
        this.props.formData.fileName ? [{
          uid: this.props.formData.id,
          name: this.props.formData.fileName,
          status: 'done',
          url: "",
        }] as UploadFile[] : [] as UploadFile[]
      ) :
        [] as UploadFile[],
    imgList: [] as any,
    loading: false,
    beforeUpload: true,
    templatUrl: this.props.formData.templatUrl,
    fileName: '',
    showUploadListInterface: { showRemoveIcon: true, showPreviewIcon: false, showDownloadIcon: false } as ShowUploadListInterface,
    // fileTypeOptions: [] as any,
  }

  // async componentWillMount() {
  //   let result = await api.wisdomcashiertemplate.getFileTypeOptions(this.props.formData.sealId)
  //   this.setState({fileTypeOptions: result.data || []})
  // }

  // 保存
  save = async (formData?: WisdomCashierTemplate) => {
    let templatUrl = this.state.templatUrl
    let fileName = this.state.fileName
    console.log("templatUrl", templatUrl);
    let { isEnabled } = formData;
    if (isEnabled === 1) {
      formData = { ...formData }
    }
    formData.templatUrl = this.state.templatUrl;
    formData.fileName = this.state.fileName;
    return this.props.mode === 1 ? await api.wisdomcashiertemplate.create(formData) : await api.wisdomcashiertemplate.update(formData);
  }
  beforeUpload = (file: any) => {
    console.log("file.type", file.type)
    const isJpgOrPng = file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || file.type === "application/msword";
    if (!isJpgOrPng) {
      message.error("只能上传.DOC/.DOCX格式的文件!");
    }
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      message.error("最大上传10MB文件!");
    }
    return isJpgOrPng && isLt10M;
  };
  // 上传模板
  handleChange = async (file: any) => {
    let { templatUrl, fileList, fileName } = this.state;
    fileList.shift();
    let imgUrl = "";
    let imgList = [];
    if (file.file.status === "uploading") {
      this.setState({ loading: true });
      return;
    }
    if (file.file.status === "done") {
      this.setState({ loading: false });
    }
    if (file.file.response && file.file.response.code === 200) {
      imgUrl = file.file.response.data;
      templatUrl = file.file.response.data;
      fileName = file.file.name;
      imgList.push({ url: file.file.response.data, Name: "文件显示" });
      if (file.fileList && file.fileList.length > 0) {
        fileList.push(file.fileList);
      }
    } else {
      return;
    }
    this.refAppForm.current.onItemValueChange('templatUrl', templatUrl)
    this.setState({
      fileList,
      file,
      templatUrl,
      fileName
    });
  };
  handleRemove = async (file: any) => {
    let { templatUrl, fileList } = this.state;
    fileList.shift();
    templatUrl = "";
    this.refAppForm.current.onItemValueChange('templatUrl', templatUrl)
    this.setState({ fileList: [], templatUrl: '' })
  }
  render() {
    // const { fileList, templatUrl, showUploadListInterface, fileTypeOptions } = this.state
    const { fileList, templatUrl, showUploadListInterface } = this.state
    let { formData, mode, id } = this.props;
    let { projectId } = formData;
    let sealId = formData.sealId;
    console.log("sealId:" + sealId)
    if (this.props.mode === 1) {
      return (
        <AppFormLayout defaultButton mode={this.props.mode} >
          <AppFormLayout.Form>
            <AppForm ref={this.refAppForm} entity='wisdom_cashier_template' loadingData={false} mode={mode} keyValue={id} formData={formData}
              save={this.save}
              afterSave={() => { this.props.afterSave && this.props.afterSave() }}>
              <AppForm.Section labelWidth={120} >
                <AppForm.Item label='模板名称'
                  field='templateName'
                  itemType={AppFormItemEnum.input} unRepeat scopeField='project_id' req />
                <AppForm.Item label='sap模板Id'
                  field='erpTempId'
                  itemType={AppFormItemEnum.input} req />

                {/* <AppForm.Item label='文件类型'
                              field='fddFileType' placeholder="文件类型请在生成单据后"
                              itemType={AppFormItemEnum.select}
                              renderOptions={() => api.wisdomcashiertemplate.getFileTypeOptions({sealId})} /> */}

                {/* 2022年4月13日 修改文件类型 改成非必填只提示在编辑时候选择 */}
                <AppForm.Item label='文件类型'
                  field='fddFileType'
                  itemType={AppFormItemEnum.input}
                  placeholder="文件类型请在生成单据后进行选择" />

                <AppForm.Item label='打印样式'
                  field='printStyle' placeholder="请选择打印样式"
                  itemType={AppFormItemEnum.select} options={printStyleOption} req />
                <AppForm.Item label='打印份数'
                  field='printCount' placeholder="请选择打印份数"
                  itemType={AppFormItemEnum.select} options={printCountOption} req />
                <AppForm.Item label='单面/双面打印'
                  field='printType' placeholder="请选择打印类型"
                  itemType={AppFormItemEnum.select} options={printTypeOption} req />
                <AppForm.Item label='签章编号'
                  field='sealId' placeholder="请选择签章"
                  dataType="number"
                  itemType={AppFormItemEnum.select}
                  renderOptions={() => api.wisdomcashierseal.getSealOptions({ projectId })} req />
                <AppForm.Item label='上传模板'
                  field='templatUrl' value={templatUrl} req
                  render={() => {
                    return (
                      <Upload
                        showUploadList={showUploadListInterface}
                        action="/api/public/uploadTicketTemplate"
                        beforeUpload={this.beforeUpload}
                        onChange={this.handleChange}
                        defaultFileList={fileList}
                        onRemove={this.handleRemove}
                      >
                        <Button disabled={this.state.fileList.length > 0 ? true : false}　>
                          <Icon type={this.state.loading ? "loading" : "plus"} /> 上传模板
                                　　　　</Button>
                      </Upload>
                    )
                  }
                  } />
              </AppForm.Section>
            </AppForm>
          </AppFormLayout.Form>
        </AppFormLayout>
      )
    } else {
      return (
        <AppFormLayout defaultButton mode={this.props.mode} >
            <AppFormLayout.Form>
              <AppForm ref={this.refAppForm} entity='wisdom_cashier_template' loadingData={false} mode={mode} keyValue={id} formData={formData}
                save={this.save}
                afterSave={() => { this.props.afterSave && this.props.afterSave() }}>
                <AppForm.Section labelWidth={120} >
                  <AppForm.Item label='模板名称'
                    field='templateName'
                    itemType={AppFormItemEnum.input} unRepeat scopeField='project_id' req />
                  <AppForm.Item label='sap模板Id'
                    field='erpTempId'
                    itemType={AppFormItemEnum.input} req />

                  <AppForm.Item label='文件类型'
                                field='fileType' placeholder="请选择文件类型"
                                itemType={AppFormItemEnum.select}
                                renderOptions={() => api.wisdomcashiertemplate.getFileTypeOptions({sealId})} req />

                  <AppForm.Item label='打印样式'
                    field='printStyle' placeholder="请选择打印样式"
                    itemType={AppFormItemEnum.select} options={printStyleOption} req />
                  <AppForm.Item label='打印份数'
                    field='printCount' placeholder="请选择打印份数"
                    itemType={AppFormItemEnum.select} options={printCountOption} req />
                  <AppForm.Item label='单面/双面打印'
                    field='printType' placeholder="请选择打印类型"
                    itemType={AppFormItemEnum.select} options={printTypeOption} req />
                  <AppForm.Item label='签章编号'
                    field='sealId' placeholder="请选择签章"
                    dataType="number"
                    itemType={AppFormItemEnum.select}
                    renderOptions={() => api.wisdomcashierseal.getSealOptions({ projectId })} req />
                  <AppForm.Item label='上传模板'
                    field='templatUrl' value={templatUrl} req
                    render={() => {
                      return (
                        <Upload
                          showUploadList={showUploadListInterface}
                          action="/api/public/uploadTicketTemplate"
                          beforeUpload={this.beforeUpload}
                          onChange={this.handleChange}
                          defaultFileList={fileList}
                          onRemove={this.handleRemove}
                        >
                          <Button disabled={this.state.fileList.length > 0 ? true : false}　>
                            <Icon type={this.state.loading ? "loading" : "plus"} /> 上传模板
                                  　　　　</Button>
                        </Upload>
                      )
                    }
                    } />
                </AppForm.Section>
              </AppForm>
            </AppFormLayout.Form>
        </AppFormLayout>
      )
    }
  }

}



// WEBPACK FOOTER //
// ./src/page/pos/template/TemplateEditForm.tsx